import GoalError from './GoalError';
class AmountBelowLastMonthRentIncome extends GoalError {
    constructor(options) {
        super('The target amount of the goal is less than the last'
            + ' month rent income when goal type is for RENTS', options);
    }
}
export default AmountBelowLastMonthRentIncome;
